@if(!!showLoader()){
    <app-loader></app-loader>
}
@if(!!tokenSignal() && !isAuthRoute()){
<app-header></app-header>
<app-sidebar></app-sidebar>
}

<router-outlet> </router-outlet>

@if(!!tokenSignal()){
<app-footer></app-footer>
}
